import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export const LoginForm = () => {
  const { t } = useTranslation();

  const handleMicrosoftLogin = () => {
    window.location.href = `${import.meta.env.VITE_BACKEND_URL}/api/auth/microsoft`;
  };

  return (
    <Button
      variant='outline'
      size='lg'
      className='w-full'
      onClick={handleMicrosoftLogin}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 23 23'
        className='size-4'>
        <path
          fill='#f35325'
          d='M1 1h10v10H1z'
        />
        <path
          fill='#81bc06'
          d='M12 1h10v10H12z'
        />
        <path
          fill='#05a6f0'
          d='M1 12h10v10H1z'
        />
        <path
          fill='#ffba08'
          d='M12 12h10v10H12z'
        />
      </svg>
      {t('auth.login.form.loginWithMicrosoft')}
    </Button>
  );
};
